import { render, staticRenderFns } from "./group_chat.vue?vue&type=template&id=61c4b6dd&scoped=true&"
import script from "./group_chat.vue?vue&type=script&lang=js&"
export * from "./group_chat.vue?vue&type=script&lang=js&"
import style0 from "./group_chat.vue?vue&type=style&index=0&id=61c4b6dd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c4b6dd",
  null
  
)

export default component.exports